import { useMemo } from "react";
import {
  Drawer,
  DrawerOverlay,
  DrawerContent,
  DrawerHeader,
  DrawerBody,
  DrawerCloseButton,
  HStack,
  Icon,
  Text,
  VStack,
} from "@chakra-ui/react";
import { TbAlertCircle } from "react-icons/tb";
import { NewHireJourneyId } from "models/newHire";
import { dedupeMissingSlackUsers } from "features/Issues/helpers";
import { useIssuesByNewHireIdQuery } from "features/Issues/hooks";
import IssueModalTag from "features/Issues/Components/IssueModal";

interface IssuesDrawerProps {
  newHireId: NewHireJourneyId;
  isOpen: boolean;
  onClose: () => void;
}

export default function IssuesDrawer({ newHireId, isOpen, onClose }: IssuesDrawerProps) {
  const { data: issues } = useIssuesByNewHireIdQuery(newHireId, { enabled: !!newHireId });
  const dedupedIssues = useMemo(() => dedupeMissingSlackUsers(issues), [issues]);
  const issueCount = dedupedIssues?.length || 0;

  return (
    <Drawer isOpen={isOpen} placement="right" onClose={onClose} size="md">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader>
          <HStack spacing={2}>
            <Icon as={TbAlertCircle} boxSize="5" color="red.600" />
            <Text>
              {issueCount} Issue{issueCount !== 1 ? "s" : ""}
            </Text>
          </HStack>
        </DrawerHeader>
        <DrawerBody>
          <VStack spacing={3} align="start">
            {dedupedIssues?.map((issue) => (
              <IssueModalTag key={issue.id} issue={issue} />
            ))}
          </VStack>
        </DrawerBody>
      </DrawerContent>
    </Drawer>
  );
}
